<div class="modal-container">
    <div class="cropper-wrapper">
        <image-cropper 
            [imageChangedEvent]="imageEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1"
            [roundCropper]="true"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (loadImageFailed)="loadImageFailed()"
            [resizeToWidth]="500"
            [resizeToHeight]="500"
            [cropperMinWidth]="150"
            [cropperMinHeight]="150"
            [onlyScaleDown]="false"
            [alignImage]="'center'"
            [cropper]="{ scalable: true, zoomable: true, movable: true }">
        </image-cropper>
    </div>
    
    <div class="row">
        <div class="col-6 buttons_col">
            <button class="btn btn-round buttons_margin" (click)="onClose()">Cancelar</button>
        </div>
        <div class="col-6 buttons_col">
            <button class="btn btn-primary btn-round buttons_margin" (click)="onImage()">Confirmar</button>
        </div>
    </div>
</div>